/**
 * Product image gallery (slick).
 *
 * Extracted from theme.js so product pages can boot the gallery as soon as
 * jQuery + slick are parsed, instead of waiting for the window "load" event
 * (which fires after every image/iframe on the page). theme.js delegates
 * halo.productImageGallery() here, so quick view / quick shop keep working.
 */
(function ($) {
  if (!$) return;

  var $doc = $(document),
    $win = $(window);

  // Same check theme.js uses to add the "safari" body class, inlined so this
  // file does not depend on theme.js having run first.
  var isSafari =
    navigator.userAgent.match(/Mac OS X.*(?:Safari|Chrome)/) &&
    !navigator.userAgent.match(/Chrome/);

  function productImageGallery($scope) {
    var sliderNav = $scope.find(".productView-nav"),
      sliderFor = $scope.find('.productView-for:not(".mobile")'),
      sliderForMobile = $scope.find(".productView-for.mobile");

    if (
      !sliderFor.hasClass("slick-initialized") &&
      !sliderNav.hasClass("slick-initialized")
    ) {
      const navArrowsDesk = sliderNav.data("arrows-desk"),
        navArrowsMobi = sliderNav.data("arrows-mobi"),
        navCounterMobi = sliderNav.data("counter-mobi"),
        navMediaCount = sliderNav.data("media-count"),
        thumbnailToShow = parseInt(sliderFor.data("max-thumbnail-to-show"));

      let checkNav, checkFor, navSlideCount;

      var appendTimeout;

      window.haloSliderNavHTML = sliderNav.html();

      sliderNav.hasClass("productView-nav-gallery")
        ? (navSlideCount = Math.round(navMediaCount / 2))
        : (navSlideCount = navMediaCount);
      sliderNav.hasClass("productView-horizontal-tabs") && navMediaCount == 2
        ? (navSlideCount = 1)
        : (navSlideCount = navMediaCount);
      let slickCounter =
        `<div class="slick-counter">
                    <span class="slick-counter--current">1</span>
                    <span aria-hidden="true">/</span>
                    <span class="slick-counter--total">` +
        navSlideCount +
        `</span>
                </div>`;

      const getSlickCounter = () => {
        setTimeout(() => {
          let countSlide = $(".productView-nav .slick-slide").length;
          if (sliderNav.hasClass("productView-nav-gallery"))
            countSlide = Math.round(countSlide / 2);
          slickCounter =
            `<div class="slick-counter">
                            <span class="slick-counter--current">1</span>
                            <span aria-hidden="true">/</span>
                            <span class="slick-counter--total">` +
            countSlide +
            `</span>
                        </div>`;
        }, 1000);
      };

      const setSlickCounter = () => {
        clearTimeout(appendTimeout);
        appendTimeout = setTimeout(() => {
          sliderNav.append(slickCounter);
        }, 1000);
      };

      sliderNav.on("init", () => {
        if (window.innerWidth < 768 && navCounterMobi) {
          if (window.variant_image_group) getSlickCounter();
          setSlickCounter();
          sliderNav.on(
            "reInit afterChange",
            function (event, slick, currentSlide, nextSlide) {
              var i = (currentSlide ? currentSlide : 0) + 1;
              sliderNav.find(".slick-counter--current").text(i);
            }
          );
        }
      });

      sliderNav.on("reInit", () => {
        if (window.innerWidth < 768 && navCounterMobi) {
          if (window.variant_image_group) getSlickCounter();
          setSlickCounter();
        }
      });

      sliderNav.closest(".productView").is(".layout-4")
        ? (checkFor = false)
        : (checkFor = sliderFor);

      if (sliderNav.hasClass("productView-nav-gallery")) {
        var sliderNav2 = $scope.find(
            ".productView-nav.productView-nav-gallery"
          ),
          length = sliderNav2.data("media-count"),
          oneItems = sliderNav2.data("1-item-mobi"),
          show = 2,
          rows = 2;

        if (length == 1) {
          show = 1;
          rows = 1;
        }
        if (length == 2) {
          show = 2;
          rows = 1;
        }

        if (oneItems && window.innerWidth < 551) {
          show = 1;
          rows = 1;
        }

        sliderNav2.slick({
          dots: true,
          rows: rows,
          arrows: navArrowsDesk,
          infinite: true,
          slidesPerRow: 1,
          slidesToShow: show,
          focusOnSelect: false,
          asNavFor: checkFor,
          nextArrow: window.arrows.icon_next,
          prevArrow: window.arrows.icon_prev,
          rtl: window.rtl_slick,
          responsive: [
            {
              breakpoint: 767,
              settings: {
                arrows: navArrowsMobi,
              },
            },
          ],
        });
        checkNav = sliderNav2;
      } else if (sliderNav.hasClass("productView-horizontal-tabs")) {
        var sliderNav2 = $scope.find(
            ".productView-nav.productView-horizontal-tabs"
          ),
          show = 2,
          rows = 1;

        sliderNav2.slick({
          dots: true,
          rows: rows,
          arrows: navArrowsDesk,
          infinite: false,
          slidesPerRow: 1,
          slidesToShow: 2,
          focusOnSelect: false,
          asNavFor: checkFor,
          nextArrow: window.arrows.icon_next,
          prevArrow: window.arrows.icon_prev,
          rtl: window.rtl_slick,
          responsive: [
            {
              breakpoint: 767,
              settings: {
                arrows: navArrowsMobi,
                get slidesToShow() {
                  if (
                    sliderNav2
                      .parents(".product-details")
                      .hasClass("featured-product")
                  ) {
                    return (this.slidesToShow = 1);
                  } else {
                    return (this.slidesToShow = 2);
                  }
                },
              },
            },
          ],
        });
        checkNav = sliderNav2;
      } else {
        if (!sliderNav.is(".style-2, .style-3") || window.innerWidth < 768) {
          sliderNav.slick({
            mobileFirst: true,
            dots: false,
            arrows: true,
            infinite: false,
            slidesToShow: 1.5,
            slidesToScroll: 1,
            asNavFor: checkFor,
            swipe: true,
            nextArrow: window.arrows.icon_next,
            prevArrow: window.arrows.icon_prev,
            rtl: window.rtl_slick,
            responsive: [
              {
                breakpoint: 768,
                settings: "unslick",
              },
            ],
          });
          checkNav = sliderNav;
        } else {
          checkNav = false;
        }
      }

      if ($scope.hasClass("layout-1") || $scope.hasClass("layout-2")) {
        sliderFor.on("init", (event, slick) => {
          sliderFor.find(".animated-loading").removeClass("animated-loading");
        });

        if (
          isSafari &&
          window.innerWidth != document.querySelector("body").clientWidth
        ) {
          sliderFor.slick({
            slidesToShow: thumbnailToShow,
            slidesToScroll: 1,
            asNavFor: checkNav,
            arrows: false,
            dots: false,
            draggable: false,
            adaptiveHeight: false,
            focusOnSelect: true,
            vertical: true,
            verticalSwiping: true,
            infinite: true,
            nextArrow: window.arrows.icon_next,
            prevArrow: window.arrows.icon_prev,
            responsive: [
              {
                breakpoint: 1601,
                settings: {
                  slidesToShow: 4,
                  vertical: true,
                  verticalSwiping: true,
                  slidesToScroll: 1,
                },
              },
              {
                breakpoint: 1280,
                settings: {
                  slidesToShow: 4,
                  vertical: false,
                },
              },
              {
                breakpoint: 1024,
                settings: {
                  slidesToShow: 4,
                  vertical: false,
                  verticalSwiping: false,
                  rtl: window.rtl_slick,
                },
              },
              {
                breakpoint: 768,
                settings: {
                  slidesToShow: 3,
                  slidesToScroll: 1,
                  vertical: false,
                  verticalSwiping: false,
                  rtl: window.rtl_slick,
                },
              },
            ],
          });
        } else {
          sliderFor.slick({
            slidesToShow: thumbnailToShow,
            slidesToScroll: 1,
            asNavFor: checkNav,
            arrows: false,
            dots: false,
            draggable: false,
            adaptiveHeight: false,
            focusOnSelect: true,
            vertical: true,
            verticalSwiping: true,
            infinite: true,
            nextArrow: window.arrows.icon_next,
            prevArrow: window.arrows.icon_prev,
            responsive: [
              {
                breakpoint: 1600,
                settings: {
                  slidesToShow: 4,
                  slidesToScroll: 1,
                  vertical: true,
                },
              },
              {
                breakpoint: 1280,
                settings: {
                  slidesToShow: 4,
                  vertical: false,
                },
              },
              {
                breakpoint: 1024,
                settings: {
                  slidesToShow: 4,
                  vertical: false,
                  verticalSwiping: false,
                  rtl: window.rtl_slick,
                },
              },
              {
                breakpoint: 767,
                settings: {
                  slidesToShow: 3,
                  slidesToScroll: 1,
                  vertical: false,
                  verticalSwiping: false,
                  rtl: window.rtl_slick,
                },
              },
            ],
          });
        }
      } else if ($scope.hasClass("layout-3")) {
        sliderFor.on("init", (event, slick) => {
          sliderFor.find(".animated-loading").removeClass("animated-loading");
        });

        sliderFor.slick({
          slidesToShow: thumbnailToShow,
          slidesToScroll: 1,
          asNavFor: checkNav,
          arrows: false,
          dots: false,
          focusOnSelect: true,
          infinite: true,
          nextArrow: window.arrows.icon_next,
          prevArrow: window.arrows.icon_prev,
          rtl: window.rtl_slick,
          responsive: [
            {
              breakpoint: 1600,
              settings: {
                slidesToShow:
                  thumbnailToShow > 3 ? thumbnailToShow - 1 : thumbnailToShow,
                slidesToScroll: 1,
              },
            },
            {
              breakpoint: 767,
              settings: {
                slidesToShow: 3,
                slidesToScroll: 1,
              },
            },
          ],
        });
      }

      $(window).on("resize", function () {
        sliderFor.slick("resize");
      });

      sliderForMobile.on("init", (event, slick) => {
        sliderForMobile
          .find(".animated-loading")
          .removeClass("animated-loading");
      });

      sliderForMobile.slick({
        slidesToShow: parseInt(sliderForMobile.data("max-thumbnail-to-show")),
        slidesToScroll: 1,
        asNavFor: checkNav,
        arrows: true,
        dots: false,
        draggable: false,
        adaptiveHeight: false,
        focusOnSelect: true,
        vertical: true,
        verticalSwiping: true,
        infinite: false,
        nextArrow: window.arrows.icon_next,
        prevArrow: window.arrows.icon_prev,
        rtl: window.rtl_slick,
        responsive: [
          {
            breakpoint: 1600,
            settings: {
              slidesToShow:
                thumbnailToShow > 3 ? thumbnailToShow - 1 : thumbnailToShow,
              slidesToScroll: 1,
            },
          },
          {
            breakpoint: 1280,
            settings: {
              slidesToShow: 3,
            },
          },
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 4,
              vertical: false,
              verticalSwiping: false,
              rtl: window.rtl_slick,
            },
          },
          {
            breakpoint: 767,
            settings: {
              slidesToShow: 1.4,
              slidesToScroll: 1,
              vertical: false,
              verticalSwiping: false,
            },
          },
        ],
      });

      if (sliderNav.find("[data-youtube]").length > 0) {
        if (typeof window.onYouTubeIframeAPIReady === "undefined") {
          window.onYouTubeIframeAPIReady = initYoutubeCarousel.bind(
            window,
            sliderNav
          );

          const tag = document.createElement("script");
          tag.src = "https://www.youtube.com/player_api";
          const firstScriptTag = document.getElementsByTagName("script")[0];
          firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
        } else {
          initYoutubeCarousel(sliderNav);
        }
      }

      if (sliderNav.find("[data-vimeo]").length > 0) {
        sliderNav.on("beforeChange", (event, slick) => {
          var currentSlide, player, command;

          currentSlide = $(slick.$slider).find(".slick-current");
          player = currentSlide.find("iframe").get(0);

          command = {
            method: "pause",
            value: "true",
          };

          if (player != undefined) {
            player.contentWindow.postMessage(JSON.stringify(command), "*");
          }
        });

        sliderNav.on("afterChange", (event, slick) => {
          var currentSlide, player, command;

          currentSlide = $(slick.$slider).find(".slick-current");
          player = currentSlide.find("iframe").get(0);

          command = {
            method: "play",
            value: "true",
          };

          if (player != undefined) {
            player.contentWindow.postMessage(JSON.stringify(command), "*");
          }
        });
      }

      if (sliderNav.find("[data-mp4]").length > 0) {
        sliderNav.on("beforeChange", (event, slick) => {
          var currentSlide, player;

          currentSlide = $(slick.$slider).find(".slick-current");
          player = currentSlide.find("video").get(0);

          if (player != undefined) {
            player.pause();
          }
        });

        sliderNav.on("afterChange", (event, slick) => {
          var currentSlide, player;

          currentSlide = $(slick.$slider).find(".slick-current");
          player = currentSlide.find("video").get(0);

          if (player != undefined) {
            player.play();
          }
        });
      }
    }

    // On mobile the main image strip is a slider, so opening the lightbox on tap
    // fights the swipe. fancybox also binds through a delegated handler on
    // [data-fancybox], so the hook has to come off the elements — not calling
    // .fancybox() below would not be enough.
    if (window.innerWidth < 768) {
      $scope
        .find(".productView-nav [data-fancybox]")
        .removeAttr("data-fancybox");
    }

    var productFancybox = $scope.find("[data-fancybox]");

    if (productFancybox.length > 0) {
      productFancybox.fancybox({
        buttons: [
          "zoom",
          "share",
          "slideShow",
          "fullScreen",
          //"download",
          "thumbs",
          "close",
        ],
        loop: true,
        thumbs: {
          autoStart: true,
        },
      });
    }
    // }

    $win.on("resize", () => {
      if ($scope.hasClass("layout-1") || $scope.hasClass("layout-2")) {
        if ($win.width() > 1279) {
          setTimeout(() => {
            if (sliderFor.find(".slick-arrow").length > 0) {
              var height_for = sliderFor.outerHeight(),
                height_nav = sliderNav.outerHeight(),
                pos = (height_nav - height_for) / 2;

              sliderFor.parent().addClass("arrows-visible");
              sliderFor.parent().css("top", pos);
            } else {
              sliderFor.parent().addClass("arrows-disable");
            }
          }, 200);
        } else {
          setTimeout(() => {
            if (sliderFor.find(".slick-arrow").length > 0) {
              sliderFor.parent().css("top", "unset");
            }
          }, 200);
        }
      }
    });
  }

  function initYoutubeCarousel(slider) {
    slider.each((index, slick) => {
      const $slick = $(slick);

      if ($slick.find("[data-youtube]").length > 0) {
        $slick.addClass("slick-slider--video");

        initYoutubeCarouselEvent(slick);
      }
    });
  }

  function initYoutubeCarouselEvent(slick) {
    var $slick = $(slick),
      $videos = $slick.find("[data-youtube]");

    bindEvents(slick);

    function bindEvents() {
      if ($slick.hasClass("slick-initialized")) {
        onSlickImageInit($slick, $videos);
      }

      $doc.on("init", $slick, onSlickImageInit);
      $doc.on("beforeChange", $slick, onSlickImageBeforeChange);
      $doc.on("afterChange", $slick, onSlickImageAfterChange);
    }

    function onPlayerReady(event) {
      $(event.target.getIframe())
        .closest(".slick-slide")
        .data("youtube-player", event.target);

      setTimeout(function () {
        if (
          $(event.target.getIframe())
            .closest(".slick-slide")
            .hasClass("slick-active")
        ) {
          $slick.slick("slickPause");
          event.target.playVideo();
        }
      }, 200);
    }

    function onPlayerStateChange(event) {
      if (event.data === YT.PlayerState.PLAYING) {
        $slick.slick("slickPause");
      }

      if (event.data === YT.PlayerState.ENDED) {
        $slick.slick("slickNext");
      }
    }

    function onSlickImageInit() {
      $videos.each((j, vid) => {
        const $vid = $(vid);
        const id = `youtube_player_${Math.floor(Math.random() * 100)}`;

        $vid.attr("id", id);

        const player = new YT.Player(id, {
          host: "http://www.youtube.com",
          videoId: $vid.data("youtube"),
          wmode: "transparent",
          playerVars: {
            autoplay: 0,
            controls: 0,
            disablekb: 1,
            enablejsapi: 1,
            fs: 0,
            rel: 0,
            showinfo: 0,
            iv_load_policy: 3,
            modestbranding: 1,
            wmode: "transparent",
          },
          events: {
            onReady: onPlayerReady,
            onStateChange: onPlayerStateChange,
          },
        });
      });
    }

    function onSlickImageBeforeChange() {
      const player = $slick
        .find(".slick-slide.slick-active")
        .data("youtube-player");

      if (player) {
        player.stopVideo();
        $slick.removeClass("slick-slider--playvideo");
      }
    }

    function onSlickImageAfterChange() {
      const player = $slick
        .find(".slick-slide.slick-active")
        .data("youtube-player");

      if (player) {
        $slick.slick("slickPause");
        $slick.addClass("slick-slider--playvideo");
        player.playVideo();
      }
    }
  }

  /**
   * Initializes the gallery for a scope once. Scopes already handled are
   * skipped, so calling this again (theme.js still does on window "load")
   * is a no-op.
   */
  function init($scope) {
    if (!$scope || !$scope.length) return;

    var pending = $scope.filter(function () {
      return !this.dataset.haloGalleryInit;
    });

    if (!pending.length) return;

    pending.each(function () {
      this.dataset.haloGalleryInit = "true";
    });

    productImageGallery(pending);
  }

  function autoInit() {
    if (
      document.body.classList.contains("template-product") ||
      $(".product-details").hasClass("featured-product")
    ) {
      init($(".halo-productView"));
    }
  }

  window.haloProductGallery = {
    init: init,
    productImageGallery: productImageGallery,
    initYoutubeCarousel: initYoutubeCarousel,
  };

  document.addEventListener("DOMContentLoaded", autoInit, { once: true });

  // Re-render of the product section in the theme editor brings fresh markup.
  document.addEventListener("shopify:section:load", function (event) {
    init($(event.target).find(".halo-productView"));
  });
})(window.jQuery);
